<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline" class="topForm">
        <div>
            <a-form-item>
                <a-input
                        v-model:value="searchForm.billNo"
                        placeholder="结算单号"
                        allowClear
                />
            </a-form-item>

          <!-- 获取供应商信息 -->
          <a-form-item>
            <df-selectSupplierShop
              :model="searchForm"
              @setValue="searchAction"
              style="width: 220px"
            ></df-selectSupplierShop>
          </a-form-item>

          <a-form-item>
            <a-range-picker
              v-model:value="searchForm.orderdate"
              :placeholder="['账单开始', '账单结束']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="searchAction"> 查询 </a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="reset">重置</a-button>
          </a-form-item>
        </div>
        <div>
          <a-form-item>
            <a-button @click="createBill">创建供应对账单</a-button>
          </a-form-item>
        </div>
      </a-form>
    </a-card>

      <!-- 创建对账单 -->
      <a-modal v-model:visible="createVisible" title="创建供应对账单" :footer="null">
          <a-spin :spinning="createSpinning">
              <a-form layout="inline">
                  <a-form-item label="选择供应：">
                      <df-selectSupplierShop
                              :model="createForm"
                              style="width: 220px"
                      ></df-selectSupplierShop>
                  </a-form-item>
                  <a-form-item label="对账时段：">
                      <a-range-picker
                              v-model:value="createForm.orderdate"
                              :placeholder="['账单开始', '账单结束']"
                              valueFormat="YYYY-MM-DD"
                              format="YYYY-MM-DD"
                      />
                  </a-form-item>
                  <div style="margin-top: 20px">
                      <a-form-item>
                          <a-button type="primary" @click="createSupplyBill">
                              确定
                          </a-button>
                      </a-form-item>
                      <a-form-item>
                          <a-button @click="createCancel">取消</a-button>
                      </a-form-item>
                  </div>
              </a-form>
          </a-spin>
      </a-modal>


    <a-card
      size="small"
      title=""
      style="margin-top: 20px"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      @tabChange="cardtabChange"
      :tabList="panes"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300 }"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:billNo="{ text, record }">
          <div @click="toDetail(record)">{{ record.billNo }}</div>
        </template>
        <template v-slot:settlementAmount="{ text, record }">
          <div v-if="record.settlementAmount != null">
            ¥{{ record.settlementAmount }}
          </div>
        </template>
        <template v-slot:outTicketAmount="{ text, record }">
          <div v-if="record.outTicketAmount != null">
            ¥{{ record.outTicketAmount }}
          </div>
        </template>
        <template v-slot:serviceAmount="{ text, record }">
          <div v-if="record.serviceAmount != null">
            ¥{{ record.serviceAmount }}
          </div>
        </template>
        <template v-slot:returnTicketAmount="{ text, record }">
          <div v-if="record.returnTicketAmount != null">
            ¥{{ record.returnTicketAmount }}
          </div>
        </template>
        <template v-slot:returnServiceAmount="{ text, record }">
          <div v-if="record.returnServiceAmount != null">
            ¥{{ record.returnServiceAmount }}
          </div>
        </template>
        <template v-slot:insuranceAmount="{ text, record }">
          <div v-if="record.insuranceAmount != null">
            ¥{{ record.insuranceAmount }}
          </div>
        </template>
        <template v-slot:checkDate="{ text, record }">
          <div>{{ record.checkBegin + " 至 " + record.checkEnd }}</div>
        </template>

        <template v-slot:operation="{ text, record }">
          <a-button
            type="primary"
            @click="toDetail(record)"
            size="small"
            style="margin-right: 10px"
          >
            查看明细
          </a-button>
          <a-button
            type="danger"
            @click="handleDelete(record)"
            size="small"
            style="margin-right: 10px"
          >
            删除
          </a-button>
          <a-button type="primary" @click="handleDownload(record)" size="small">
            下载
          </a-button>
        </template>
      </a-table>
    </a-card>
    <!-- 导入对账单  弃用 -->
    <!--<a-modal v-model:visible="createVisible" title="导入对账单" :footer="null">
      <a-spin :spinning="createSpinning">
        <a-form layout="inline">
          <a-form-item label="选择供应：">
            <df-selectSupplierShop
              :model="createForm"
              style="width: 220px"
            ></df-selectSupplierShop>
          </a-form-item>
          <a-form-item label="对账时段：">
            <a-range-picker
              v-model:value="createForm.orderdate"
              :placeholder="['账单开始', '账单结束']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-item>

          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="creatRow"
          >
            <a-col :span="4">
              <CloudDownloadOutlined />
            </a-col>

            <a-col :span="20">
              <p>填写导入数据信息</p>
              <p>
                请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
              </p>
              <p @click="templateDownload" style="color: #1bba79">下载模板</p>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="creatRow"
          >
            <a-col :span="4">
              <CloudUploadOutlined />
            </a-col>
            <a-col :span="20">
              <p>上传填好的信息表</p>
              <p>
                文件后缀名必须为xls 或xlsx
                （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据
              </p>
              <a-upload
                :fileList="fileList"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                accept=".xlsx,.xls"
              >
                <p class="handle" style="color: #1bba79;font-weight:normal">上传文件</p>
              </a-upload>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="tipRow"
          >
            <a-col :span="3">
              <ExclamationCircleOutlined />
            </a-col>
            <a-col :span="21">
              <p>特别提示</p>
              <p>单号不能重复</p>
            </a-col>
          </a-row>

          <a-form-item>
            <a-button type="primary" @click="createCancel"> 取消 </a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="handleUpload">上传</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>-->
    <df-pagination :model="pageObj"></df-pagination>
  </div>
</template>

<script>
import { ref, reactive, provide, createVNode } from "vue";
import financialApi from "@axios/financial";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { useRouter } from "vue-router";
import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";
export default {
  name: "insurance",
  components: {
    CloudDownloadOutlined,
    CloudUploadOutlined,
    ExclamationCircleOutlined,
    UploadOutlined,
  },
  setup() {
    const router = useRouter();

    let activeKey = ref("0");

    let searchForm = reactive({
      supplierId: "",
      orderdate: [],
        billNo: "",
    });

    let searchParams = reactive({
      supplierId: "",
      tktsStartTime: "",
      tktsEndTime: "",
    });

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const searchAction = (data) => {
     /* console.log("-------------");
      console.log(data);*/
      searchParams.supplierId = searchForm.supplierId;
      if (searchForm.orderdate) {
        searchParams.tktsStartTime = searchForm.orderdate[0];
        searchParams.tktsEndTime = searchForm.orderdate[1];
      } else {
        searchParams.tktsStartTime = "";
        searchParams.tktsEndTime = "";
      }
        searchParams.billNo = searchForm.billNo;
      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    let list = ref([]);

    let loading = ref(false);

    const getList = () => {
      let params = {
        billType: activeKey.value == "0" ? null : activeKey.value,
          billNo: searchParams.billNo ? searchParams.billNo : null,
        supplierId: searchParams.supplierId ? searchParams.supplierId : null,
        checkBegin: searchParams.tktsStartTime
          ? searchParams.tktsStartTime
          : null,
        checkEnd: searchParams.tktsEndTime ? searchParams.tktsEndTime : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      loading.value = true;

      financialApi.getSupplierList(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };

    getList();

    const reset = () => {
      searchForm.supplierId = "";
      searchForm.orderdate = [];
        searchForm.billNo = "";
      searchAction();
    };

    // 创建对账单
    let createVisible = ref(false);
    const createBill = () => {
      createVisible.value = true;
    };
    let createForm = reactive({
      supplierId: "",
      orderdate: [],
    });

    let createParams = reactive({
      supplierId: "",
      tktsStartTime: "",
      tktsEndTime: "",
    });
    const createCancel = () => {
      createVisible.value = false;
    };
   /* // 下载模板
    const templateDownload = () => {
      let params = {};
      let fileName = "模板";
      exportOut(
        params, // 导出请求参数
        "/app-finance/supplier/bill/download/template", // 接口地址
        fileName // 导出文件名字
      );
    };*/

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };
    // 文件上传
    let createSpinning = ref(false);
    let fileList = ref([]);
    const handleRemove = (file) => {
      // 移除文件时，要重新给fileList赋值
      let arr = [];
      for (let i = 0; i < fileList.value.length; i++) {
        if (fileList.value[i].uid !== file.uid) {
          arr.push(fileList.value[i]);
        }
      }
      fileList.value = arr;
      console.log(fileList.value);
    };
    // 上传前校验
    const beforeUpload = (file) => {
      console.log(file);
      // const isXlsOrXlsx = file.name.split(".")[1] === ("xls" || "xlsx");
      // if (!isXlsOrXlsx) {
      //   message.error("只能上传xls 或xlsx （即Excel格式）!");
      // }
      // const isLt10M = file.size / 1024 / 1024 < 10;
      // if (!isLt10M) {
      //   message.error("文件大小不得大于10M!");
      // }
      // return isXlsOrXlsx && isLt10M;
      fileList.value = [...fileList.value, file];
      return false;
    };

    // 此处用作使用日期和供应信息来创建对账单。
   //  const handleUpload = () => {
    const createSupplyBill = () => {
      console.log(createForm.orderdate.length);
      if (
        createForm.supplierId !== "" &&
        createForm.supplierId !== undefined &&
        createForm.orderdate.length !== 0
      ) {
        createSpinning.value = true;
        createParams.supplierId = createForm.supplierId;
        if (createForm.orderdate) {
          createParams.tktsStartTime = createForm.orderdate[0];
          createParams.tktsEndTime = createForm.orderdate[1];
        } else {
          createParams.tktsStartTime = "";
          createParams.tktsEndTime = "";
        }
          /* console.log(createParams);
          console.log(fileList.value);
            const formData = new FormData();
           fileList.value.forEach((file) => {
             formData.append("file", file);
               console.log(file);
           });
        formData.append("supplierId", createParams.supplierId);
        formData.append("checkBegin", createParams.tktsStartTime);
        formData.append("checkEnd", createParams.tktsEndTime);*/

          let params = {
              supplierId: createParams.supplierId
                  ? createParams.supplierId
                  : null,
              checkBegin: createParams.tktsStartTime
                  ? createParams.tktsStartTime
                  : null,
              checkEnd: createParams.tktsEndTime ? createParams.tktsEndTime : null,
          };


        financialApi.createSupplyBill(params).then((res) => {
          console.log(res);
         // fileList.value = [];
          message.success("创建成功");
          createSpinning.value = false;
          createVisible.value = false;
          getList();
        });
      } else {
        message.info("您有必要信息未填写！");
      }
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    // 删除供应
    const handleDelete = (item) => {
      console.log(item);
      Modal.confirm({
        title: "是否确认删除？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          financialApi.delSupplier(item.id).then((res) => {
            console.log(res);
            message.success("删除成功");
            getList();
          });
        },
        onCancel() {},
      });
    };

    const handleDownload = (item) => {
      let params = {
        billNo: item.billNo,
      };
      let fileName = "供应结算单明细-" + item.billNo;
      exportOut(
        params, // 导出请求参数
        "/app-finance/supplier/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    let panes = ref([
      { tab: "全部", key: "0" },
      { tab: "日结算单", key: "10" },
      { tab: "账期结算单", key: "20" },
    ]);
    const getSupplierBillCount = () => {
      // let params = {
      //   billNo: billNo
      // };
      financialApi.getSupplierBillCount().then((res) => {
        console.log(res);
        panes.value = [
          { tab: "全部", key: "0" },
          { tab: `日结算单(${res.autoCount})`, key: "10" },
          { tab: `账期结算单(${res.manuallyCount})`, key: "20" },
        ];
      });
    };
    getSupplierBillCount();

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    // 详情
    const toDetail = (row) => {
      console.log(row);
      router.push({
        name: "supplyFinancialDetail",
        query: {
          id: row.id,
          billNo: row.billNo,
          supplierId: row.supplierId,
          checkBegin: row.checkBegin,
          checkEnd: row.checkEnd,
        },
      });
    };

    return {
      activeKey,
      cardtabChange,
      panes,
      handleDelete,
      handleDownload,
      loading,
      list,
      pageObj,
      searchForm,
      searchAction,
      reset,
      columns: [
        {
          title: "对账单号",
          dataIndex: "billNo",
          width: 200,
          align: "center",
          slots: { customRender: "billNo" },
          className: `${"underlineStyle"}`,
        },
        {
          title: "供应商",
          dataIndex: "supplierName",
          width: 120,
          align: "center",
        },
        {
          title: "结算金额",
          dataIndex: "settlementAmount",
          width: 120,
          align: "center",
          slots: { customRender: "settlementAmount" },
        },
        {
          title: "出票量",
          dataIndex: "outTicketNum",
          width: 120,
          align: "center",
        },
         /* {
              title: "改签量",
              dataIndex: "outTicketNum",
              width: 120,
              align: "center",
          },*/
          {
              title: "退票量",
              dataIndex: "returnTicketNum",
              width: 120,
              align: "center",
          },
        {
          title: "出票金额",
          dataIndex: "outTicketAmount",
          width: 120,
          align: "center",
          slots: { customRender: "outTicketAmount" },
        },
        {
          title: "出票服务费",
          dataIndex: "serviceAmount",
          width: 120,
          align: "center",
          slots: { customRender: "serviceAmount" },
        },
        {
          title: "退票金额",
          dataIndex: "returnTicketAmount",
          width: 120,
          align: "center",
          slots: { customRender: "returnTicketAmount" },
        },
        {
          title: "退票手续费",
          dataIndex: "returnServiceAmount",
          width: 150,
          align: "center",
          slots: { customRender: "returnServiceAmount" },
        },
       /* {
          title: "保险金额",
          dataIndex: "insuranceAmount",
          width: 100,
          align: "center",
          slots: { customRender: "insuranceAmount" },
        },*/
        {
          title: "生成时间",
          dataIndex: "createTime",
          width: 150,
          align: "center",
        },
        {
          title: "对账时段",
          dataIndex: "checkDate",
          width: 340,
          align: "center",
          slots: { customRender: "checkDate" },
        },
        {
          title: "是否完结",
          dataIndex: "isFinishValue",
          width: 100,
          align: "center",
        },
        {
          title: "对账人",
          dataIndex: "checkUserName",
          width: 100,
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "",
          width: 250,
          align: "center",
          slots: { customRender: "operation" },
          fixed: "right",
        },
      ],
      toDetail,
      createBill,
      createVisible,
      createForm,
      createParams,
     // templateDownload,
      createCancel,
      fileList,
      beforeUpload,
      handleRemove,
        createSupplyBill,
      // handleUpload,
      createSpinning,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
.creatRow {
  border: 1px solid #f5f5f5;
  margin-bottom: 15px;
  .ant-col-4 {
    text-align: center;
    font-size: 30px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
      color: #666;
    }
    &:nth-of-type(3) {
      color: #40a9ff;
      cursor: pointer;
    }
  }
  .handle {
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 10px;
    color: #40a9ff;
    cursor: pointer;
  }
}
.tipRow {
  border: 1px solid #ffe58f;
  margin-bottom: 15px;
  background: #fffbe6;
  color: #888;
  .ant-col-3 {
    text-align: center;
    font-size: 20px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
    }
  }
}
.topForm {
  display: flex;
  justify-content: space-between;
}
</style>
